import React from 'react';
import { IntlProvider } from 'react-intl-next';

import type { ComponentMap, Extension } from '../ui';
import { RendererNext } from '../ui';
import { makeMockUserPicker } from '../components/UIKit/userpicker';
import { elementToForgeDoc } from '../utils/elementToForgeDoc';
import { makeMockUser } from './makeMockUser';

// set of components that should be wrapped with the experimental skeleton overlay
const COMPONENTS_TO_WRAP: Record<string, boolean> = {
	Button: true,
	Heading: true,
	Image: true,
	Link: true,
	Text: true,
	Textfield: true,
};

export const shouldWrapComponent = (componentType: string): boolean => {
	return COMPONENTS_TO_WRAP[componentType];
};

interface RenderForgeDocFromJSXProps {
	config?: { client?: any; components?: ComponentMap; forgeReactMajorVersion?: number };
	elem: React.ReactElement;
	shouldWrapWithSkeletonOverlay?: boolean;
}

export const RenderForgeDocFromJSX = ({
	elem,
	config,
	shouldWrapWithSkeletonOverlay = false,
}: RenderForgeDocFromJSXProps): React.JSX.Element => {
	const forgeDoc = elementToForgeDoc(elem);

	return (
		<IntlProvider locale="en">
			<RendererNext
				shouldWrapWithSkeletonOverlay={shouldWrapWithSkeletonOverlay}
				forgeDoc={{
					...forgeDoc,
					forgeReactMajorVersion: config?.forgeReactMajorVersion,
				}}
				extension={{} as Extension}
				// @ts-ignore dispatch is not used
				dispatch={() => {}}
				components={(defaults) => ({
					...defaults,
					User: makeMockUser(),
					UserGroup: () => <>Mock User Group</>,
					UserPicker: makeMockUserPicker({
						query: () =>
							Promise.resolve([
								{ id: '1', name: 'John', avatarUrl: '', type: 'user' },
								{ id: '2', name: 'Jane', avatarUrl: '', type: 'user' },
							]),
					}),
					// Handles React's fragment component in VR tests for UI kit 2(non-codegen)
					Fragment: ({ forgeDoc, render }) => <>{forgeDoc.children.map(render)}</>,
					...config?.components,
				})}
				isNative
				loading
			/>
		</IntlProvider>
	);
};
